import { Apple, Leaf, Package } from 'lucide-react'
import type { Product } from '../types'
import React from 'react'

export const CARD_MIN_WIDTH       = 240
export const CARD_GAP             = 20
export const CARD_HEIGHT          = 300
export const VIRTUALIZE_THRESHOLD = 50
export const OVERSCAN             = 2


export const statusConfig: Record<Product['status'], { label: string; dotColor: string; cls: string; bg: string; text: string; dot: string }> = {
  active:    { label: 'מכירה פעילה', dotColor: '#40916C', cls: 'bg-[#D8F3DC] text-[#1B4332]', bg: '#D8F3DC', text: '#1B4332', dot: '#40916C' },
  sale:      { label: 'מבצע',        dotColor: '#F0A500', cls: 'bg-[#FFF3CD] text-[#856404]', bg: '#FFF3CD', text: '#856404', dot: '#F0A500' },
  sold_out:  { label: 'אזל',         dotColor: '#E74C3C', cls: 'bg-[#FFE8E0] text-[#C0392B]', bg: '#FFE8E0', text: '#C0392B', dot: '#E74C3C' },
  suspended: { label: 'מושהה',       dotColor: '#F0F6FC', cls: 'bg-[#6e6660] text-[#F0F6FC]', bg: '#6e6660', text: '#F0F6FC', dot: '#F0F6FC' },
  draft:     { label: 'טיוטה',       dotColor: '#6366F1', cls: 'bg-[#EEF2FF] text-[#3730A3]', bg: '#EEF2FF', text: '#3730A3', dot: '#6366F1' },
  other:     { label: 'אחר',         dotColor: '#A89F97', cls: 'bg-[#F2EDE4] text-[#6B6560]', bg: '#F2EDE4', text: '#6B6560', dot: '#A89F97' },
}

export const unitLabels: Record<Product['unit'], string> = {
  kg: 'ק"ג', unit: 'יחידה', carton: 'קרטון', pallet: 'משטח', container: 'מיכל',
}

export const CATEGORIES = [
  { value: 'all',        label: 'הכל',   Icon: null },
  { value: 'fruits',     label: 'פירות', Icon: Apple },
  { value: 'vegetables', label: 'ירקות', Icon: Leaf  },
] as const

export const cardBgClasses = ['card-bg-peach', 'card-bg-green', 'card-bg-green-fresh']

export const CategoryIcon = ({ category, className = 'w-5 h-5' }: { category: string | undefined; className?: string }) => {
  if (category === 'fruits')     return React.createElement(Apple, { className })
  if (category === 'vegetables') return React.createElement(Leaf,  { className })
  return React.createElement(Package, { className })
}